import { CommunicationService } from '../../../../services/communication.service';
import { SCREEN_SIZE } from '../../../../classes/enums';
var AgentReviewsComponent = /** @class */ (function () {
    function AgentReviewsComponent(communicationService) {
        this.communicationService = communicationService;
        this.SCREEN_SIZE = SCREEN_SIZE;
        this.currentPage = 0;
        this.totalPages = 0;
        this.pageSize = 3;
    }
    Object.defineProperty(AgentReviewsComponent.prototype, "setRating", {
        set: function (r) {
            this.rating = r;
            this.reviews = r.reviews;
            this.reviews.forEach(function (review) {
                review.content = review.content
                    .replace(/<\/?p>/g, '') // remove <p> tags
                    .replace(/<\s*br\s*\/>/g, '\n'); // replace <br/> with newlines
            });
            this.totalPages = Math.ceil(this.reviews.length / this.pageSize);
        },
        enumerable: true,
        configurable: true
    });
    return AgentReviewsComponent;
}());
export { AgentReviewsComponent };
